var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 60,
    height: 60,
    rx: 30
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "M5.25 5.25h49.5v49.5H5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M16.776 23.66v4.366h7.109v3.66h-7.109v7.556H13V20h14.453l3.776 11.137 2.917-7.346L32.635 20h3.75l4.297 10.693L43.938 20H48l-7.396 19.948-4.557-11.399L30.734 40l-6.297-16.34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c5594488e93bf0c2d8bc2fab9c83a61f.svg";
export { ForwardRef as ReactComponent };